import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/partner/opportunityFunnel";

/**
 * 商机漏斗页接口
 */
export default {
    /** 查询商机漏斗，返回漏斗层 + 阶段明细 */
    funnel: (data) => axios.get({url: `${PREFIX_URI}/funnel`, data}),
}
